import React from 'react';
import { FrameButton } from '../Components/Frame';
import { GameStatus } from '@entities/GameStatus';
import { Icon } from '../Components/Icon';
import { StarsBackground } from '../Components/StarsBackground';

interface TitleScreenProps {
  setGameStatus: React.Dispatch<React.SetStateAction<GameStatus>>;
}

export const TitleScreen: React.FC<TitleScreenProps> = ({ setGameStatus }) => {
  return (
    <div>
      <div className="fixed top-[17%] -translate-y-1/2 left-[20%] right-[20%] text-primary text-title text-center">
        CAN YOU CORRECTLY IDENTIFY THE THYROID LESIONS?
      </div>
      <div className="fixed top-[46%] -translate-y-1/2 left-1/2 -translate-x-1/2 z-50 scale-75">
        <svg
          width="1033"
          height="444"
          viewBox="0 0 1033 444"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g filter="url(#filter0_d_842_2875)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M97.1667 99.461C101.078 92.5863 108.379 88.3405 116.288 88.3405H270.382C274.191 88.3405 277.874 86.9817 280.771 84.5085L304.392 64.3404C311.453 58.3119 320.432 55 329.716 55H703.502C712.57 55 721.354 58.1596 728.344 63.9354L753.444 84.6747C756.311 87.0442 759.915 88.3405 763.635 88.3405H910.191C917.681 88.3405 924.656 92.1508 928.703 98.4529L975.548 171.402C979.637 177.77 975.065 186.139 967.498 186.139C962.214 186.139 957.931 190.423 957.931 195.707V247.042C957.931 252.542 962.389 257 967.889 257C975.526 257 980.321 265.244 976.544 271.882L935.695 343.678C931.783 350.553 924.483 354.799 916.573 354.799H762.48C758.671 354.799 754.987 356.157 752.09 358.631L728.469 378.799C721.409 384.827 712.429 388.139 703.145 388.139L329.359 388.139C320.292 388.139 311.507 384.98 304.517 379.204L279.418 358.464C276.55 356.095 272.946 354.799 269.226 354.799L122.671 354.799C115.181 354.799 108.206 350.988 104.159 344.686L57.3132 271.737C53.2243 265.369 57.7963 257 65.3634 257C70.6473 257 74.9307 252.717 74.9307 247.433V196.097C74.9307 190.598 70.4723 186.139 64.9727 186.139C57.3349 186.139 52.5405 177.895 56.3175 171.257L97.1667 99.461Z"
              fill="url(#paint0_radial_842_2875)"
            />
            <path
              d="M97.1667 99.461L92.8209 96.9884H92.8209L97.1667 99.461ZM304.392 64.3404L307.639 68.1429V68.1429L304.392 64.3404ZM728.344 63.9354L731.529 60.081V60.081L728.344 63.9354ZM928.703 98.4529L932.91 95.7512V95.7512L928.703 98.4529ZM935.695 343.678L940.041 346.151L935.695 343.678ZM728.469 378.799L731.716 382.601H731.716L728.469 378.799ZM703.145 388.139V393.139V388.139ZM329.359 388.139V383.139V388.139ZM304.517 379.204L301.332 383.058H301.332L304.517 379.204ZM122.671 354.799V349.799V354.799ZM104.159 344.686L99.9516 347.388L104.159 344.686ZM56.3175 171.257L51.9717 168.784L56.3175 171.257ZM752.09 358.631L748.844 354.828L752.09 358.631ZM279.418 358.464L276.233 362.319L279.418 358.464ZM269.226 354.799V349.799V354.799ZM975.548 171.402L979.755 168.701L975.548 171.402ZM753.444 84.6747L750.259 88.5291L753.444 84.6747ZM57.3132 271.737L61.5204 269.035L57.3132 271.737ZM976.544 271.882L980.89 274.355L976.544 271.882ZM116.288 83.3405C106.581 83.3405 97.6212 88.5513 92.8209 96.9884L101.513 101.934C104.535 96.6214 110.176 93.3405 116.288 93.3405V83.3405ZM270.382 83.3405H116.288V93.3405H270.382V83.3405ZM301.145 60.5379L277.524 80.706L284.018 88.3111L307.639 68.1429L301.145 60.5379ZM329.716 50C319.242 50 309.111 53.7365 301.145 60.5379L307.639 68.1429C313.794 62.8873 321.622 60 329.716 60V50ZM703.502 50H329.716V60H703.502V50ZM731.529 60.081C723.643 53.5647 713.732 50 703.502 50V60C711.407 60 719.065 62.7545 725.159 67.7898L731.529 60.081ZM756.628 80.8203L731.529 60.081L725.159 67.7898L750.259 88.5291L756.628 80.8203ZM910.191 83.3405H763.635V93.3405H910.191V83.3405ZM932.91 95.7512C927.943 88.0168 919.383 83.3405 910.191 83.3405V93.3405C915.978 93.3405 921.368 96.2848 924.495 101.155L932.91 95.7512ZM979.755 168.701L932.91 95.7512L924.495 101.155L971.341 174.104L979.755 168.701ZM952.931 195.707V247.042H962.931V195.707H952.931ZM940.041 346.151L980.89 274.355L972.198 269.41L931.349 341.206L940.041 346.151ZM916.573 359.799C926.28 359.799 935.24 354.588 940.041 346.151L931.349 341.206C928.326 346.518 922.685 349.799 916.573 349.799V359.799ZM762.48 359.799H916.573V349.799H762.48V359.799ZM731.716 382.601L755.337 362.433L748.844 354.828L725.223 374.996L731.716 382.601ZM703.145 393.139C713.62 393.139 723.75 389.403 731.716 382.601L725.223 374.996C719.067 380.252 711.239 383.139 703.145 383.139V393.139ZM329.359 393.139L703.145 393.139V383.139L329.359 383.139V393.139ZM301.332 383.058C309.219 389.574 319.129 393.139 329.359 393.139V383.139C321.454 383.139 313.796 380.385 307.702 375.349L301.332 383.058ZM276.233 362.319L301.332 383.058L307.702 375.349L282.603 354.61L276.233 362.319ZM122.671 359.799L269.226 359.799V349.799L122.671 349.799V359.799ZM99.9516 347.388C104.918 355.122 113.479 359.799 122.671 359.799V349.799C116.883 349.799 111.493 346.854 108.366 341.984L99.9516 347.388ZM53.106 274.438L99.9516 347.388L108.366 341.984L61.5204 269.035L53.106 274.438ZM79.9307 247.433V196.097H69.9307V247.433H79.9307ZM92.8209 96.9884L51.9717 168.784L60.6633 173.729L101.513 101.934L92.8209 96.9884ZM64.9727 181.139C61.1699 181.139 58.7828 177.035 60.6633 173.729L51.9717 168.784C46.2982 178.756 53.4999 191.139 64.9727 191.139V181.139ZM79.9307 196.097C79.9307 187.836 73.2337 181.139 64.9727 181.139V191.139C67.7109 191.139 69.9307 193.359 69.9307 196.097H79.9307ZM270.382 93.3405C275.381 93.3405 280.216 91.5571 284.018 88.3111L277.524 80.706C275.533 82.4064 273 83.3405 270.382 83.3405V93.3405ZM65.3634 262C73.4087 262 79.9307 255.478 79.9307 247.433H69.9307C69.9307 249.955 67.8859 252 65.3634 252V262ZM762.48 349.799C757.481 349.799 752.646 351.582 748.844 354.828L755.337 362.433C757.328 360.733 759.861 359.799 762.48 359.799V349.799ZM967.498 181.139C959.453 181.139 952.931 187.661 952.931 195.707H962.931C962.931 193.184 964.976 191.139 967.498 191.139V181.139ZM282.603 354.61C278.839 351.5 274.109 349.799 269.226 349.799V359.799C271.784 359.799 274.261 360.69 276.233 362.319L282.603 354.61ZM971.341 174.104C973.293 177.144 971.11 181.139 967.498 181.139V191.139C979.02 191.139 985.981 178.396 979.755 168.701L971.341 174.104ZM952.931 247.042C952.931 255.303 959.628 262 967.889 262V252C965.15 252 962.931 249.78 962.931 247.042H952.931ZM750.259 88.5291C754.023 91.6392 758.753 93.3405 763.635 93.3405V83.3405C761.078 83.3405 758.6 82.4493 756.628 80.8203L750.259 88.5291ZM61.5204 269.035C59.5684 265.995 61.751 262 65.3634 262V252C53.8416 252 46.8802 264.743 53.106 274.438L61.5204 269.035ZM967.889 262C971.691 262 974.079 266.105 972.198 269.41L980.89 274.355C986.563 264.383 979.361 252 967.889 252V262Z"
              fill="#4D6471"
            />
            <g filter="url(#filter1_i_842_2875)">
              <path
                d="M324.993 327.293C321.2 324.873 322.915 319 327.414 319H380C383.314 319 386 321.686 386 325V343C386 346.314 383.314 349 380 349H360.752C359.608 349 358.488 348.673 357.523 348.058L324.993 327.293Z"
                fill="#C9D4DA"
              />
              <path
                d="M324.993 327.293C321.2 324.873 322.915 319 327.414 319H380C383.314 319 386 321.686 386 325V343C386 346.314 383.314 349 380 349H360.752C359.608 349 358.488 348.673 357.523 348.058L324.993 327.293Z"
                fill="url(#paint1_linear_842_2875)"
                fillOpacity="0.2"
              />
            </g>
            <g filter="url(#filter2_i_842_2875)">
              <rect
                x="403"
                y="319"
                width="64"
                height="30"
                rx="6"
                fill="#FFD990"
              />
              <rect
                x="403"
                y="319"
                width="64"
                height="30"
                rx="6"
                fill="url(#paint2_linear_842_2875)"
                fillOpacity="0.2"
              />
            </g>
            <g filter="url(#filter3_i_842_2875)">
              <rect
                x="484"
                y="319"
                width="64"
                height="30"
                rx="6"
                fill="#FFA048"
              />
              <rect
                x="484"
                y="319"
                width="64"
                height="30"
                rx="6"
                fill="url(#paint3_linear_842_2875)"
                fillOpacity="0.2"
              />
            </g>
            <g filter="url(#filter4_i_842_2875)">
              <rect
                x="565"
                y="319"
                width="64"
                height="30"
                rx="6"
                fill="#F85E1D"
              />
              <rect
                x="565"
                y="319"
                width="64"
                height="30"
                rx="6"
                fill="url(#paint4_linear_842_2875)"
                fillOpacity="0.2"
              />
            </g>
            <g filter="url(#filter5_i_842_2875)">
              <path
                d="M707.007 327.293C710.8 324.873 709.085 319 704.586 319H652C648.686 319 646 321.686 646 325V343C646 346.314 648.686 349 652 349H671.248C672.392 349 673.512 348.673 674.477 348.058L707.007 327.293Z"
                fill="#E62C4C"
              />
              <path
                d="M707.007 327.293C710.8 324.873 709.085 319 704.586 319H652C648.686 319 646 321.686 646 325V343C646 346.314 648.686 349 652 349H671.248C672.392 349 673.512 348.673 674.477 348.058L707.007 327.293Z"
                fill="url(#paint5_linear_842_2875)"
                fillOpacity="0.2"
              />
            </g>
            <g filter="url(#filter6_d_842_2875)">
              <mask
                id="path-8-outside-1_842_2875"
                maskUnits="userSpaceOnUse"
                x="120.327"
                y="100.594"
                width="787"
                height="176"
                fill="black"
              >
                <rect
                  fill="white"
                  x="120.327"
                  y="100.594"
                  width="787"
                  height="176"
                />
                <path d="M126.327 177.925V158.909H215.922V177.925H182.523V268H159.725V177.925H126.327Z" />
                <path d="M253.741 158.909V268H230.677V158.909H253.741Z" />
                <path d="M323.268 204.452V222.457H273.517V204.452H323.268Z" />
                <path d="M343.03 268V158.909H386.07C394.309 158.909 401.34 160.383 407.164 163.33C413.023 166.242 417.48 170.379 420.534 175.741C423.623 181.068 425.168 187.336 425.168 194.545C425.168 201.789 423.606 208.021 420.481 213.241C417.356 218.426 412.828 222.403 406.898 225.173C401.003 227.943 393.865 229.328 385.484 229.328H356.667V210.791H381.755C386.159 210.791 389.817 210.187 392.728 208.98C395.64 207.773 397.807 205.961 399.227 203.547C400.683 201.132 401.411 198.131 401.411 194.545C401.411 190.922 400.683 187.868 399.227 185.383C397.807 182.897 395.623 181.015 392.675 179.736C389.763 178.422 386.088 177.765 381.649 177.765H366.095V268H343.03ZM401.944 218.355L429.057 268H403.595L377.068 218.355H401.944Z" />
                <path d="M460.271 268H435.555L473.215 158.909H502.938L540.545 268H515.829L488.503 183.838H487.65L460.271 268ZM458.726 225.12H517.107V243.124H458.726V225.12Z" />
                <path d="M592.347 268H553.675V158.909H592.666C603.639 158.909 613.085 161.093 621.004 165.461C628.923 169.793 635.014 176.025 639.275 184.157C643.572 192.29 645.72 202.02 645.72 213.348C645.72 224.711 643.572 234.477 639.275 242.645C635.014 250.812 628.888 257.08 620.898 261.448C612.943 265.816 603.426 268 592.347 268ZM576.739 248.238H591.388C598.206 248.238 603.941 247.03 608.593 244.616C613.281 242.165 616.796 238.383 619.14 233.27C621.519 228.121 622.709 221.48 622.709 213.348C622.709 205.287 621.519 198.699 619.14 193.586C616.796 188.472 613.298 184.708 608.646 182.293C603.994 179.878 598.259 178.671 591.441 178.671H576.739V248.238Z" />
                <path d="M662.38 268V186.182H685.071V268H662.38Z" />
                <path d="M740.216 269.598C731.835 269.598 724.627 267.822 718.59 264.271C712.588 260.685 707.972 255.713 704.74 249.356C701.544 243 699.946 235.685 699.946 227.41C699.946 219.03 701.562 211.679 704.793 205.358C708.06 199.001 712.695 194.047 718.696 190.496C724.698 186.91 731.835 185.116 740.109 185.116C747.247 185.116 753.497 186.412 758.859 189.005C764.222 191.597 768.465 195.237 771.59 199.925C774.715 204.612 776.438 210.116 776.757 216.437H755.344C754.74 212.354 753.142 209.069 750.55 206.583C747.993 204.062 744.637 202.801 740.482 202.801C736.967 202.801 733.895 203.76 731.267 205.677C728.675 207.559 726.651 210.312 725.195 213.934C723.739 217.556 723.011 221.942 723.011 227.091C723.011 232.311 723.721 236.75 725.141 240.408C726.597 244.065 728.639 246.853 731.267 248.77C733.895 250.688 736.967 251.647 740.482 251.647C743.075 251.647 745.401 251.114 747.46 250.049C749.556 248.984 751.278 247.439 752.627 245.415C754.012 243.355 754.918 240.887 755.344 238.011H776.757C776.402 244.261 774.698 249.765 771.644 254.523C768.625 259.246 764.453 262.94 759.126 265.603C753.799 268.266 747.496 269.598 740.216 269.598Z" />
                <path d="M814.617 269.545C809.397 269.545 804.745 268.639 800.661 266.828C796.577 264.981 793.346 262.265 790.966 258.678C788.622 255.056 787.451 250.546 787.451 245.148C787.451 240.603 788.285 236.785 789.954 233.696C791.623 230.606 793.896 228.121 796.772 226.239C799.649 224.356 802.916 222.936 806.573 221.977C810.267 221.018 814.137 220.344 818.186 219.953C822.944 219.456 826.779 218.994 829.691 218.568C832.603 218.106 834.716 217.432 836.03 216.544C837.344 215.656 838.001 214.342 838.001 212.602V212.282C838.001 208.909 836.936 206.299 834.805 204.452C832.71 202.606 829.727 201.682 825.856 201.682C821.772 201.682 818.523 202.588 816.108 204.399C813.693 206.175 812.095 208.412 811.314 211.111L790.327 209.406C791.392 204.434 793.488 200.138 796.613 196.515C799.738 192.858 803.768 190.052 808.704 188.099C813.676 186.111 819.429 185.116 825.963 185.116C830.508 185.116 834.858 185.649 839.013 186.714C843.203 187.78 846.914 189.431 850.146 191.668C853.413 193.905 855.988 196.782 857.87 200.297C859.752 203.778 860.693 207.95 860.693 212.815V268H839.173V256.654H838.534C837.22 259.211 835.462 261.466 833.26 263.419C831.059 265.337 828.413 266.846 825.323 267.947C822.234 269.012 818.665 269.545 814.617 269.545ZM821.115 253.884C824.453 253.884 827.401 253.227 829.958 251.913C832.515 250.564 834.521 248.753 835.977 246.48C837.433 244.207 838.161 241.633 838.161 238.756V230.074C837.451 230.535 836.474 230.962 835.231 231.352C834.024 231.707 832.657 232.045 831.13 232.364C829.603 232.648 828.076 232.915 826.549 233.163C825.022 233.376 823.637 233.572 822.394 233.749C819.73 234.14 817.404 234.761 815.416 235.614C813.427 236.466 811.882 237.62 810.782 239.076C809.681 240.496 809.13 242.272 809.13 244.403C809.13 247.492 810.249 249.854 812.486 251.487C814.759 253.085 817.635 253.884 821.115 253.884Z" />
                <path d="M900.989 158.909V268H878.298V158.909H900.989Z" />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M683.103 106.644C684.164 106.842 685.023 107.613 685.318 108.632L690.33 125.917L707.672 131.801C708.694 132.148 709.431 133.031 709.573 134.08C709.716 135.129 709.239 136.161 708.343 136.743L693.152 146.615L692.946 164.539C692.934 165.596 692.31 166.55 691.337 167C690.364 167.45 689.21 167.317 688.361 166.658L673.961 155.476L656.492 160.692C655.462 160.999 654.339 160.706 653.594 159.935C652.85 159.164 652.613 158.049 652.984 157.059L659.275 140.273L648.684 125.575C648.059 124.709 647.988 123.574 648.5 122.647C649.012 121.721 650.019 121.164 651.097 121.21L669.393 121.998L680.317 107.696C680.961 106.853 682.041 106.445 683.103 106.644ZM681.438 115.535L673.053 126.512C672.497 127.241 671.608 127.652 670.677 127.612L656.63 127.007L664.761 138.291C665.302 139.041 665.433 140 665.112 140.857L660.283 153.74L673.693 149.736C674.583 149.47 675.554 149.652 676.288 150.222L687.341 158.805L687.5 145.048C687.51 144.133 687.979 143.286 688.755 142.782L700.417 135.204L687.103 130.687C686.22 130.387 685.54 129.682 685.285 128.802L681.438 115.535Z"
                />
              </mask>
              <path
                d="M126.327 177.925V158.909H215.922V177.925H182.523V268H159.725V177.925H126.327Z"
                fill="url(#paint6_linear_842_2875)"
              />
              <path
                d="M253.741 158.909V268H230.677V158.909H253.741Z"
                fill="url(#paint7_linear_842_2875)"
              />
              <path
                d="M323.268 204.452V222.457H273.517V204.452H323.268Z"
                fill="url(#paint8_linear_842_2875)"
              />
              <path
                d="M343.03 268V158.909H386.07C394.309 158.909 401.34 160.383 407.164 163.33C413.023 166.242 417.48 170.379 420.534 175.741C423.623 181.068 425.168 187.336 425.168 194.545C425.168 201.789 423.606 208.021 420.481 213.241C417.356 218.426 412.828 222.403 406.898 225.173C401.003 227.943 393.865 229.328 385.484 229.328H356.667V210.791H381.755C386.159 210.791 389.817 210.187 392.728 208.98C395.64 207.773 397.807 205.961 399.227 203.547C400.683 201.132 401.411 198.131 401.411 194.545C401.411 190.922 400.683 187.868 399.227 185.383C397.807 182.897 395.623 181.015 392.675 179.736C389.763 178.422 386.088 177.765 381.649 177.765H366.095V268H343.03ZM401.944 218.355L429.057 268H403.595L377.068 218.355H401.944Z"
                fill="url(#paint9_linear_842_2875)"
              />
              <path
                d="M460.271 268H435.555L473.215 158.909H502.938L540.545 268H515.829L488.503 183.838H487.65L460.271 268ZM458.726 225.12H517.107V243.124H458.726V225.12Z"
                fill="url(#paint10_linear_842_2875)"
              />
              <path
                d="M592.347 268H553.675V158.909H592.666C603.639 158.909 613.085 161.093 621.004 165.461C628.923 169.793 635.014 176.025 639.275 184.157C643.572 192.29 645.72 202.02 645.72 213.348C645.72 224.711 643.572 234.477 639.275 242.645C635.014 250.812 628.888 257.08 620.898 261.448C612.943 265.816 603.426 268 592.347 268ZM576.739 248.238H591.388C598.206 248.238 603.941 247.03 608.593 244.616C613.281 242.165 616.796 238.383 619.14 233.27C621.519 228.121 622.709 221.48 622.709 213.348C622.709 205.287 621.519 198.699 619.14 193.586C616.796 188.472 613.298 184.708 608.646 182.293C603.994 179.878 598.259 178.671 591.441 178.671H576.739V248.238Z"
                fill="url(#paint11_linear_842_2875)"
              />
              <path
                d="M662.38 268V186.182H685.071V268H662.38Z"
                fill="url(#paint12_linear_842_2875)"
              />
              <path
                d="M740.216 269.598C731.835 269.598 724.627 267.822 718.59 264.271C712.588 260.685 707.972 255.713 704.74 249.356C701.544 243 699.946 235.685 699.946 227.41C699.946 219.03 701.562 211.679 704.793 205.358C708.06 199.001 712.695 194.047 718.696 190.496C724.698 186.91 731.835 185.116 740.109 185.116C747.247 185.116 753.497 186.412 758.859 189.005C764.222 191.597 768.465 195.237 771.59 199.925C774.715 204.612 776.438 210.116 776.757 216.437H755.344C754.74 212.354 753.142 209.069 750.55 206.583C747.993 204.062 744.637 202.801 740.482 202.801C736.967 202.801 733.895 203.76 731.267 205.677C728.675 207.559 726.651 210.312 725.195 213.934C723.739 217.556 723.011 221.942 723.011 227.091C723.011 232.311 723.721 236.75 725.141 240.408C726.597 244.065 728.639 246.853 731.267 248.77C733.895 250.688 736.967 251.647 740.482 251.647C743.075 251.647 745.401 251.114 747.46 250.049C749.556 248.984 751.278 247.439 752.627 245.415C754.012 243.355 754.918 240.887 755.344 238.011H776.757C776.402 244.261 774.698 249.765 771.644 254.523C768.625 259.246 764.453 262.94 759.126 265.603C753.799 268.266 747.496 269.598 740.216 269.598Z"
                fill="url(#paint13_linear_842_2875)"
              />
              <path
                d="M814.617 269.545C809.397 269.545 804.745 268.639 800.661 266.828C796.577 264.981 793.346 262.265 790.966 258.678C788.622 255.056 787.451 250.546 787.451 245.148C787.451 240.603 788.285 236.785 789.954 233.696C791.623 230.606 793.896 228.121 796.772 226.239C799.649 224.356 802.916 222.936 806.573 221.977C810.267 221.018 814.137 220.344 818.186 219.953C822.944 219.456 826.779 218.994 829.691 218.568C832.603 218.106 834.716 217.432 836.03 216.544C837.344 215.656 838.001 214.342 838.001 212.602V212.282C838.001 208.909 836.936 206.299 834.805 204.452C832.71 202.606 829.727 201.682 825.856 201.682C821.772 201.682 818.523 202.588 816.108 204.399C813.693 206.175 812.095 208.412 811.314 211.111L790.327 209.406C791.392 204.434 793.488 200.138 796.613 196.515C799.738 192.858 803.768 190.052 808.704 188.099C813.676 186.111 819.429 185.116 825.963 185.116C830.508 185.116 834.858 185.649 839.013 186.714C843.203 187.78 846.914 189.431 850.146 191.668C853.413 193.905 855.988 196.782 857.87 200.297C859.752 203.778 860.693 207.95 860.693 212.815V268H839.173V256.654H838.534C837.22 259.211 835.462 261.466 833.26 263.419C831.059 265.337 828.413 266.846 825.323 267.947C822.234 269.012 818.665 269.545 814.617 269.545ZM821.115 253.884C824.453 253.884 827.401 253.227 829.958 251.913C832.515 250.564 834.521 248.753 835.977 246.48C837.433 244.207 838.161 241.633 838.161 238.756V230.074C837.451 230.535 836.474 230.962 835.231 231.352C834.024 231.707 832.657 232.045 831.13 232.364C829.603 232.648 828.076 232.915 826.549 233.163C825.022 233.376 823.637 233.572 822.394 233.749C819.73 234.14 817.404 234.761 815.416 235.614C813.427 236.466 811.882 237.62 810.782 239.076C809.681 240.496 809.13 242.272 809.13 244.403C809.13 247.492 810.249 249.854 812.486 251.487C814.759 253.085 817.635 253.884 821.115 253.884Z"
                fill="url(#paint14_linear_842_2875)"
              />
              <path
                d="M900.989 158.909V268H878.298V158.909H900.989Z"
                fill="url(#paint15_linear_842_2875)"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M683.103 106.644C684.164 106.842 685.023 107.613 685.318 108.632L690.33 125.917L707.672 131.801C708.694 132.148 709.431 133.031 709.573 134.08C709.716 135.129 709.239 136.161 708.343 136.743L693.152 146.615L692.946 164.539C692.934 165.596 692.31 166.55 691.337 167C690.364 167.45 689.21 167.317 688.361 166.658L673.961 155.476L656.492 160.692C655.462 160.999 654.339 160.706 653.594 159.935C652.85 159.164 652.613 158.049 652.984 157.059L659.275 140.273L648.684 125.575C648.059 124.709 647.988 123.574 648.5 122.647C649.012 121.721 650.019 121.164 651.097 121.21L669.393 121.998L680.317 107.696C680.961 106.853 682.041 106.445 683.103 106.644ZM681.438 115.535L673.053 126.512C672.497 127.241 671.608 127.652 670.677 127.612L656.63 127.007L664.761 138.291C665.302 139.041 665.433 140 665.112 140.857L660.283 153.74L673.693 149.736C674.583 149.47 675.554 149.652 676.288 150.222L687.341 158.805L687.5 145.048C687.51 144.133 687.979 143.286 688.755 142.782L700.417 135.204L687.103 130.687C686.22 130.387 685.54 129.682 685.285 128.802L681.438 115.535Z"
                fill="url(#paint16_linear_842_2875)"
              />
              <path
                d="M126.327 177.925V158.909H215.922V177.925H182.523V268H159.725V177.925H126.327Z"
                stroke="#0A161D"
                strokeWidth="12"
                strokeLinejoin="round"
                mask="url(#path-8-outside-1_842_2875)"
              />
              <path
                d="M253.741 158.909V268H230.677V158.909H253.741Z"
                stroke="#0A161D"
                strokeWidth="12"
                strokeLinejoin="round"
                mask="url(#path-8-outside-1_842_2875)"
              />
              <path
                d="M323.268 204.452V222.457H273.517V204.452H323.268Z"
                stroke="#0A161D"
                strokeWidth="12"
                strokeLinejoin="round"
                mask="url(#path-8-outside-1_842_2875)"
              />
              <path
                d="M343.03 268V158.909H386.07C394.309 158.909 401.34 160.383 407.164 163.33C413.023 166.242 417.48 170.379 420.534 175.741C423.623 181.068 425.168 187.336 425.168 194.545C425.168 201.789 423.606 208.021 420.481 213.241C417.356 218.426 412.828 222.403 406.898 225.173C401.003 227.943 393.865 229.328 385.484 229.328H356.667V210.791H381.755C386.159 210.791 389.817 210.187 392.728 208.98C395.64 207.773 397.807 205.961 399.227 203.547C400.683 201.132 401.411 198.131 401.411 194.545C401.411 190.922 400.683 187.868 399.227 185.383C397.807 182.897 395.623 181.015 392.675 179.736C389.763 178.422 386.088 177.765 381.649 177.765H366.095V268H343.03ZM401.944 218.355L429.057 268H403.595L377.068 218.355H401.944Z"
                stroke="#0A161D"
                strokeWidth="12"
                strokeLinejoin="round"
                mask="url(#path-8-outside-1_842_2875)"
              />
              <path
                d="M460.271 268H435.555L473.215 158.909H502.938L540.545 268H515.829L488.503 183.838H487.65L460.271 268ZM458.726 225.12H517.107V243.124H458.726V225.12Z"
                stroke="#0A161D"
                strokeWidth="12"
                strokeLinejoin="round"
                mask="url(#path-8-outside-1_842_2875)"
              />
              <path
                d="M592.347 268H553.675V158.909H592.666C603.639 158.909 613.085 161.093 621.004 165.461C628.923 169.793 635.014 176.025 639.275 184.157C643.572 192.29 645.72 202.02 645.72 213.348C645.72 224.711 643.572 234.477 639.275 242.645C635.014 250.812 628.888 257.08 620.898 261.448C612.943 265.816 603.426 268 592.347 268ZM576.739 248.238H591.388C598.206 248.238 603.941 247.03 608.593 244.616C613.281 242.165 616.796 238.383 619.14 233.27C621.519 228.121 622.709 221.48 622.709 213.348C622.709 205.287 621.519 198.699 619.14 193.586C616.796 188.472 613.298 184.708 608.646 182.293C603.994 179.878 598.259 178.671 591.441 178.671H576.739V248.238Z"
                stroke="#0A161D"
                strokeWidth="12"
                strokeLinejoin="round"
                mask="url(#path-8-outside-1_842_2875)"
              />
              <path
                d="M662.38 268V186.182H685.071V268H662.38Z"
                stroke="#0A161D"
                strokeWidth="12"
                strokeLinejoin="round"
                mask="url(#path-8-outside-1_842_2875)"
              />
              <path
                d="M740.216 269.598C731.835 269.598 724.627 267.822 718.59 264.271C712.588 260.685 707.972 255.713 704.74 249.356C701.544 243 699.946 235.685 699.946 227.41C699.946 219.03 701.562 211.679 704.793 205.358C708.06 199.001 712.695 194.047 718.696 190.496C724.698 186.91 731.835 185.116 740.109 185.116C747.247 185.116 753.497 186.412 758.859 189.005C764.222 191.597 768.465 195.237 771.59 199.925C774.715 204.612 776.438 210.116 776.757 216.437H755.344C754.74 212.354 753.142 209.069 750.55 206.583C747.993 204.062 744.637 202.801 740.482 202.801C736.967 202.801 733.895 203.76 731.267 205.677C728.675 207.559 726.651 210.312 725.195 213.934C723.739 217.556 723.011 221.942 723.011 227.091C723.011 232.311 723.721 236.75 725.141 240.408C726.597 244.065 728.639 246.853 731.267 248.77C733.895 250.688 736.967 251.647 740.482 251.647C743.075 251.647 745.401 251.114 747.46 250.049C749.556 248.984 751.278 247.439 752.627 245.415C754.012 243.355 754.918 240.887 755.344 238.011H776.757C776.402 244.261 774.698 249.765 771.644 254.523C768.625 259.246 764.453 262.94 759.126 265.603C753.799 268.266 747.496 269.598 740.216 269.598Z"
                stroke="#0A161D"
                strokeWidth="12"
                strokeLinejoin="round"
                mask="url(#path-8-outside-1_842_2875)"
              />
              <path
                d="M814.617 269.545C809.397 269.545 804.745 268.639 800.661 266.828C796.577 264.981 793.346 262.265 790.966 258.678C788.622 255.056 787.451 250.546 787.451 245.148C787.451 240.603 788.285 236.785 789.954 233.696C791.623 230.606 793.896 228.121 796.772 226.239C799.649 224.356 802.916 222.936 806.573 221.977C810.267 221.018 814.137 220.344 818.186 219.953C822.944 219.456 826.779 218.994 829.691 218.568C832.603 218.106 834.716 217.432 836.03 216.544C837.344 215.656 838.001 214.342 838.001 212.602V212.282C838.001 208.909 836.936 206.299 834.805 204.452C832.71 202.606 829.727 201.682 825.856 201.682C821.772 201.682 818.523 202.588 816.108 204.399C813.693 206.175 812.095 208.412 811.314 211.111L790.327 209.406C791.392 204.434 793.488 200.138 796.613 196.515C799.738 192.858 803.768 190.052 808.704 188.099C813.676 186.111 819.429 185.116 825.963 185.116C830.508 185.116 834.858 185.649 839.013 186.714C843.203 187.78 846.914 189.431 850.146 191.668C853.413 193.905 855.988 196.782 857.87 200.297C859.752 203.778 860.693 207.95 860.693 212.815V268H839.173V256.654H838.534C837.22 259.211 835.462 261.466 833.26 263.419C831.059 265.337 828.413 266.846 825.323 267.947C822.234 269.012 818.665 269.545 814.617 269.545ZM821.115 253.884C824.453 253.884 827.401 253.227 829.958 251.913C832.515 250.564 834.521 248.753 835.977 246.48C837.433 244.207 838.161 241.633 838.161 238.756V230.074C837.451 230.535 836.474 230.962 835.231 231.352C834.024 231.707 832.657 232.045 831.13 232.364C829.603 232.648 828.076 232.915 826.549 233.163C825.022 233.376 823.637 233.572 822.394 233.749C819.73 234.14 817.404 234.761 815.416 235.614C813.427 236.466 811.882 237.62 810.782 239.076C809.681 240.496 809.13 242.272 809.13 244.403C809.13 247.492 810.249 249.854 812.486 251.487C814.759 253.085 817.635 253.884 821.115 253.884Z"
                stroke="#0A161D"
                strokeWidth="12"
                strokeLinejoin="round"
                mask="url(#path-8-outside-1_842_2875)"
              />
              <path
                d="M900.989 158.909V268H878.298V158.909H900.989Z"
                stroke="#0A161D"
                strokeWidth="12"
                strokeLinejoin="round"
                mask="url(#path-8-outside-1_842_2875)"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M683.103 106.644C684.164 106.842 685.023 107.613 685.318 108.632L690.33 125.917L707.672 131.801C708.694 132.148 709.431 133.031 709.573 134.08C709.716 135.129 709.239 136.161 708.343 136.743L693.152 146.615L692.946 164.539C692.934 165.596 692.31 166.55 691.337 167C690.364 167.45 689.21 167.317 688.361 166.658L673.961 155.476L656.492 160.692C655.462 160.999 654.339 160.706 653.594 159.935C652.85 159.164 652.613 158.049 652.984 157.059L659.275 140.273L648.684 125.575C648.059 124.709 647.988 123.574 648.5 122.647C649.012 121.721 650.019 121.164 651.097 121.21L669.393 121.998L680.317 107.696C680.961 106.853 682.041 106.445 683.103 106.644ZM681.438 115.535L673.053 126.512C672.497 127.241 671.608 127.652 670.677 127.612L656.63 127.007L664.761 138.291C665.302 139.041 665.433 140 665.112 140.857L660.283 153.74L673.693 149.736C674.583 149.47 675.554 149.652 676.288 150.222L687.341 158.805L687.5 145.048C687.51 144.133 687.979 143.286 688.755 142.782L700.417 135.204L687.103 130.687C686.22 130.387 685.54 129.682 685.285 128.802L681.438 115.535Z"
                stroke="#0A161D"
                strokeWidth="12"
                strokeLinejoin="round"
                mask="url(#path-8-outside-1_842_2875)"
              />
            </g>
          </g>
          <defs>
            <filter
              id="filter0_d_842_2875"
              x="-0.00732422"
              y="0"
              width="1032.88"
              height="443.139"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset />
              <feGaussianBlur stdDeviation="25" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_842_2875"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_842_2875"
                result="shape"
              />
            </filter>
            <filter
              id="filter1_i_842_2875"
              x="322.906"
              y="319"
              width="63.0942"
              height="32"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="2" />
              <feGaussianBlur stdDeviation="4" />
              <feComposite
                in2="hardAlpha"
                operator="arithmetic"
                k2="-1"
                k3="1"
              />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
              />
              <feBlend
                mode="normal"
                in2="shape"
                result="effect1_innerShadow_842_2875"
              />
            </filter>
            <filter
              id="filter2_i_842_2875"
              x="403"
              y="319"
              width="64"
              height="32"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="2" />
              <feGaussianBlur stdDeviation="4" />
              <feComposite
                in2="hardAlpha"
                operator="arithmetic"
                k2="-1"
                k3="1"
              />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
              />
              <feBlend
                mode="normal"
                in2="shape"
                result="effect1_innerShadow_842_2875"
              />
            </filter>
            <filter
              id="filter3_i_842_2875"
              x="484"
              y="319"
              width="64"
              height="32"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="2" />
              <feGaussianBlur stdDeviation="4" />
              <feComposite
                in2="hardAlpha"
                operator="arithmetic"
                k2="-1"
                k3="1"
              />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
              />
              <feBlend
                mode="normal"
                in2="shape"
                result="effect1_innerShadow_842_2875"
              />
            </filter>
            <filter
              id="filter4_i_842_2875"
              x="565"
              y="319"
              width="64"
              height="32"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="2" />
              <feGaussianBlur stdDeviation="4" />
              <feComposite
                in2="hardAlpha"
                operator="arithmetic"
                k2="-1"
                k3="1"
              />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
              />
              <feBlend
                mode="normal"
                in2="shape"
                result="effect1_innerShadow_842_2875"
              />
            </filter>
            <filter
              id="filter5_i_842_2875"
              x="646"
              y="319"
              width="63.0942"
              height="32"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="2" />
              <feGaussianBlur stdDeviation="4" />
              <feComposite
                in2="hardAlpha"
                operator="arithmetic"
                k2="-1"
                k3="1"
              />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
              />
              <feBlend
                mode="normal"
                in2="shape"
                result="effect1_innerShadow_842_2875"
              />
            </filter>
            <filter
              id="filter6_d_842_2875"
              x="100.327"
              y="80.5945"
              width="826.663"
              height="215.003"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset />
              <feGaussianBlur stdDeviation="10" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0.611765 0 0 0 0 0.690196 0 0 0 0 0.737255 0 0 0 1 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_842_2875"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_842_2875"
                result="shape"
              />
            </filter>
            <radialGradient
              id="paint0_radial_842_2875"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(516.431 221.57) rotate(90) scale(166.57 461.431)"
            >
              <stop offset="0.150422" stopColor="#3C6781" />
              <stop offset="0.916667" stopColor="#213846" />
            </radialGradient>
            <linearGradient
              id="paint1_linear_842_2875"
              x1="349"
              y1="319"
              x2="349"
              y2="349"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="white" />
              <stop offset="1" stopColor="white" stopOpacity="0" />
            </linearGradient>
            <linearGradient
              id="paint2_linear_842_2875"
              x1="435"
              y1="319"
              x2="435"
              y2="349"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="white" />
              <stop offset="1" stopColor="white" stopOpacity="0" />
            </linearGradient>
            <linearGradient
              id="paint3_linear_842_2875"
              x1="516"
              y1="319"
              x2="516"
              y2="349"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="white" />
              <stop offset="1" stopColor="white" stopOpacity="0" />
            </linearGradient>
            <linearGradient
              id="paint4_linear_842_2875"
              x1="597"
              y1="319"
              x2="597"
              y2="349"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="white" />
              <stop offset="1" stopColor="white" stopOpacity="0" />
            </linearGradient>
            <linearGradient
              id="paint5_linear_842_2875"
              x1="683"
              y1="319"
              x2="683"
              y2="349"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="white" />
              <stop offset="1" stopColor="white" stopOpacity="0" />
            </linearGradient>
            <linearGradient
              id="paint6_linear_842_2875"
              x1="516"
              y1="122"
              x2="516"
              y2="304"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0.291667" stopColor="#00FFBA" />
              <stop offset="1" stopColor="#006449" />
            </linearGradient>
            <linearGradient
              id="paint7_linear_842_2875"
              x1="516"
              y1="122"
              x2="516"
              y2="304"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0.291667" stopColor="#00FFBA" />
              <stop offset="1" stopColor="#006449" />
            </linearGradient>
            <linearGradient
              id="paint8_linear_842_2875"
              x1="516"
              y1="122"
              x2="516"
              y2="304"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0.291667" stopColor="#00FFBA" />
              <stop offset="1" stopColor="#006449" />
            </linearGradient>
            <linearGradient
              id="paint9_linear_842_2875"
              x1="516"
              y1="122"
              x2="516"
              y2="304"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0.291667" stopColor="#00FFBA" />
              <stop offset="1" stopColor="#006449" />
            </linearGradient>
            <linearGradient
              id="paint10_linear_842_2875"
              x1="516"
              y1="122"
              x2="516"
              y2="304"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0.291667" stopColor="#00FFBA" />
              <stop offset="1" stopColor="#006449" />
            </linearGradient>
            <linearGradient
              id="paint11_linear_842_2875"
              x1="516"
              y1="122"
              x2="516"
              y2="304"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0.291667" stopColor="#00FFBA" />
              <stop offset="1" stopColor="#006449" />
            </linearGradient>
            <linearGradient
              id="paint12_linear_842_2875"
              x1="516"
              y1="122"
              x2="516"
              y2="304"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0.291667" stopColor="#00FFBA" />
              <stop offset="1" stopColor="#006449" />
            </linearGradient>
            <linearGradient
              id="paint13_linear_842_2875"
              x1="516"
              y1="122"
              x2="516"
              y2="304"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0.291667" stopColor="#00FFBA" />
              <stop offset="1" stopColor="#006449" />
            </linearGradient>
            <linearGradient
              id="paint14_linear_842_2875"
              x1="516"
              y1="122"
              x2="516"
              y2="304"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0.291667" stopColor="#00FFBA" />
              <stop offset="1" stopColor="#006449" />
            </linearGradient>
            <linearGradient
              id="paint15_linear_842_2875"
              x1="516"
              y1="122"
              x2="516"
              y2="304"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0.291667" stopColor="#00FFBA" />
              <stop offset="1" stopColor="#006449" />
            </linearGradient>
            <linearGradient
              id="paint16_linear_842_2875"
              x1="516"
              y1="122"
              x2="516"
              y2="304"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0.291667" stopColor="#00FFBA" />
              <stop offset="1" stopColor="#006449" />
            </linearGradient>
          </defs>
        </svg>
      </div>
      <div className="fixed top-[70%] -translate-y-1/2 left-[20%] right-[20%] text-neutral-50 text-display1 text-center">
        Press START To Play!
      </div>
      <div className="fixed top-[80%] left-1/2 -translate-x-1/2 z-50 flex gap-10">
        <FrameButton onClick={() => setGameStatus(GameStatus.Leaderboard)}>
          <Icon name="trophy-wire-frame" />
          Leaderboard
        </FrameButton>
        <FrameButton
          variant="primary"
          onClick={() => setGameStatus(GameStatus.Ready)}
        >
          <Icon name="controller" />
          START
        </FrameButton>
      </div>
      <StarsBackground prewarm />
    </div>
  );
};
